export default __webpack_public_path__ + "static/media/exit-platform-oval.1097a63e.svg";